
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySleetShowersPolartwilightColour as ObiLightningHeavySleetShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-sleet-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightningHeavySleetShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-sleet-showers-polartwilight-colour',
   elementClass: ObiLightningHeavySleetShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 